/**
 * Owner: Masa Bayu
 * File: text-formatting.ts
 * Date:Time: 2026-09-26 10:20
 * Description: FD-01 paragraph format and FD-02 canonical color value.
 */
export const QXW_FORMATTING_EXTENSION = 'FD-01';
/** Typography distance for FD-01. Not settings.units. Not page geometry. */
export const QXW_TEXT_AUTHORING_DISTANCE_UNIT = 'pt';
export const QX_TEXT_LINE_SPACING_VALUES = [
    'single',
    'one-point-one-five',
    'one-point-five',
    'double',
];
export const QX_TEXT_ALIGNMENT_VALUES = ['left', 'center', 'right', 'justify'];
const COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
export function canonicalQXTextColorValue(value) {
    if (!COLOR_PATTERN.test(value)) {
        return null;
    }
    return `#${value.slice(1).toUpperCase()}`;
}
export function isQXTextLineSpacing(value) {
    return QX_TEXT_LINE_SPACING_VALUES.includes(value);
}
export function isQXTextAlignment(value) {
    return QX_TEXT_ALIGNMENT_VALUES.includes(value);
}
export function isUnsignedAuthoringPoint(value) {
    return Number.isFinite(value) && value >= 0;
}
export function isSignedAuthoringPoint(value) {
    return Number.isFinite(value);
}
//# sourceMappingURL=text-formatting.js.map